module.exports = function extractLocation(locationDto) {
    if(!locationDto)
        return undefined;

    return {
        latitude: locationDto.Latitude,
        longitude: locationDto.Longitude,
        street: locationDto.Street,
        streetNumber: locationDto.StreetNumber,
        postalCode: locationDto.PostalCode,
        city: locationDto.City,
    };
};
